import { OperationsListItem } from "app/area/experience-transfer/operations/types-store";

export const createOperationsList = (id: number, listItems: OperationsListItem[]) => {
  return listItems.reduce((acc, item) =>
    [...acc, item.id === id ? { ...item, active: !item.active } : item],
    []);
};
